import { useOpenBaas } from "../Context/SdkBaasOpen";

function useLogoutAllSesion() {
  const { uri, accessToken } = useOpenBaas();
  const logoutAllSessions = async () => {
    try {
      await fetch(`${uri}/v1/sesions/logoutAllSessions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
    } catch (error) {
      console.error("Error logging out from all sessions:", error);
    }
  };

  // Call the logout function when needed, e.g., on a button click
  // <button onClick={logoutAllSessions}>Logout from All Sessions</button>
  return { logoutAllSessions };
}

export default useLogoutAllSesion;
